export const FOCUS_TRANSCRIPT_WORD_EVENT = "focusTranscriptWordAtTime";

export const focusTranscriptWordAtTime = (srcTimeSec: number): void => {
    if (!Number.isFinite(srcTimeSec)) return;
    try {
        window.dispatchEvent(
            new CustomEvent(FOCUS_TRANSCRIPT_WORD_EVENT, {
                detail: { srcTimeSec },
            }),
        );
    } catch {}
};
